// Utility to translate Bible book names in references
const BOOK_TRANSLATIONS: Record<string, Record<string, string>> = {
  en: {
    genesis: "Genesis", exodus: "Exodus", leviticus: "Leviticus", numbers: "Numbers",
    deuteronomy: "Deuteronomy", joshua: "Joshua", judges: "Judges", ruth: "Ruth",
    "1samuel": "1 Samuel", "2samuel": "2 Samuel", "1kings": "1 Kings", "2kings": "2 Kings",
    "1chronicles": "1 Chronicles", "2chronicles": "2 Chronicles", ezra: "Ezra", nehemiah: "Nehemiah",
    esther: "Esther", job: "Job", psalms: "Psalms", proverbs: "Proverbs",
    ecclesiastes: "Ecclesiastes", songofsolomon: "Song of Solomon", isaiah: "Isaiah",
    jeremiah: "Jeremiah", lamentations: "Lamentations", ezekiel: "Ezekiel", daniel: "Daniel",
    hosea: "Hosea", joel: "Joel", amos: "Amos", obadiah: "Obadiah", jonah: "Jonah",
    micah: "Micah", nahum: "Nahum", habakkuk: "Habakkuk", zephaniah: "Zephaniah",
    haggai: "Haggai", zechariah: "Zechariah", malachi: "Malachi",
    matthew: "Matthew", mark: "Mark", luke: "Luke", john: "John", acts: "Acts",
    romans: "Romans", "1corinthians": "1 Corinthians", "2corinthians": "2 Corinthians",
    galatians: "Galatians", ephesians: "Ephesians", philippians: "Philippians",
    colossians: "Colossians", "1thessalonians": "1 Thessalonians", "2thessalonians": "2 Thessalonians",
    "1timothy": "1 Timothy", "2timothy": "2 Timothy", titus: "Titus", philemon: "Philemon",
    hebrews: "Hebrews", james: "James", "1peter": "1 Peter", "2peter": "2 Peter",
    "1john": "1 John", "2john": "2 John", "3john": "3 John", jude: "Jude", revelation: "Revelation"
  },
  ru: {
    genesis: "Бытие", exodus: "Исход", leviticus: "Левит", numbers: "Числа",
    deuteronomy: "Второзаконие", joshua: "Иисус Навин", judges: "Судьи", ruth: "Руфь",
    "1samuel": "1 Царств", "2samuel": "2 Царств", "1kings": "3 Царств", "2kings": "4 Царств",
    "1chronicles": "1 Паралипоменон", "2chronicles": "2 Паралипоменон", ezra: "Ездра", nehemiah: "Неемия",
    esther: "Есфирь", job: "Иов", psalms: "Псалтирь", proverbs: "Притчи",
    ecclesiastes: "Екклесиаст", songofsolomon: "Песнь Песней", isaiah: "Исаия",
    jeremiah: "Иеремия", lamentations: "Плач Иеремии", ezekiel: "Иезекииль", daniel: "Даниил",
    hosea: "Осия", joel: "Иоиль", amos: "Амос", obadiah: "Авдий", jonah: "Иона",
    micah: "Михей", nahum: "Наум", habakkuk: "Аввакум", zephaniah: "Софония",
    haggai: "Аггей", zechariah: "Захария", malachi: "Малахия",
    matthew: "Матфея", mark: "Марка", luke: "Луки", john: "Иоанна", acts: "Деяния",
    romans: "Римлянам", "1corinthians": "1 Коринфянам", "2corinthians": "2 Коринфянам",
    galatians: "Галатам", ephesians: "Ефесянам", philippians: "Филиппийцам",
    colossians: "Колоссянам", "1thessalonians": "1 Фессалоникийцам", "2thessalonians": "2 Фессалоникийцам",
    "1timothy": "1 Тимофею", "2timothy": "2 Тимофею", titus: "Титу", philemon: "Филимону",
    hebrews: "Евреям", james: "Иакова", "1peter": "1 Петра", "2peter": "2 Петра",
    "1john": "1 Иоанна", "2john": "2 Иоанна", "3john": "3 Иоанна", jude: "Иуды", revelation: "Откровение"
  },
  es: {
    genesis: "Génesis", exodus: "Éxodo", leviticus: "Levítico", numbers: "Números",
    deuteronomy: "Deuteronomio", joshua: "Josué", judges: "Jueces", ruth: "Rut",
    "1samuel": "1 Samuel", "2samuel": "2 Samuel", "1kings": "1 Reyes", "2kings": "2 Reyes",
    "1chronicles": "1 Crónicas", "2chronicles": "2 Crónicas", ezra: "Esdras", nehemiah: "Nehemías",
    esther: "Ester", job: "Job", psalms: "Salmos", proverbs: "Proverbios",
    ecclesiastes: "Eclesiastés", songofsolomon: "Cantar de los Cantares", isaiah: "Isaías",
    jeremiah: "Jeremías", lamentations: "Lamentaciones", ezekiel: "Ezequiel", daniel: "Daniel",
    hosea: "Oseas", joel: "Joel", amos: "Amós", obadiah: "Abdías", jonah: "Jonás",
    micah: "Miqueas", nahum: "Nahúm", habakkuk: "Habacuc", zephaniah: "Sofonías",
    haggai: "Hageo", zechariah: "Zacarías", malachi: "Malaquías",
    matthew: "Mateo", mark: "Marcos", luke: "Lucas", john: "Juan", acts: "Hechos",
    romans: "Romanos", "1corinthians": "1 Corintios", "2corinthians": "2 Corintios",
    galatians: "Gálatas", ephesians: "Efesios", philippians: "Filipenses",
    colossians: "Colosenses", "1thessalonians": "1 Tesalonicenses", "2thessalonians": "2 Tesalonicenses",
    "1timothy": "1 Timoteo", "2timothy": "2 Timoteo", titus: "Tito", philemon: "Filemón",
    hebrews: "Hebreos", james: "Santiago", "1peter": "1 Pedro", "2peter": "2 Pedro",
    "1john": "1 Juan", "2john": "2 Juan", "3john": "3 Juan", jude: "Judas", revelation: "Apocalipsis"
  }
};

// Map all possible input variations to book keys (includes singular/plural forms)
const INPUT_TO_KEY: Record<string, Record<string, string>> = {
  en: {
    "genesis": "genesis", "exodus": "exodus", "leviticus": "leviticus", "numbers": "numbers",
    "deuteronomy": "deuteronomy", "joshua": "joshua", "judges": "judges", "ruth": "ruth",
    "1 samuel": "1samuel", "2 samuel": "2samuel", "1 kings": "1kings", "2 kings": "2kings",
    "1 chronicles": "1chronicles", "2 chronicles": "2chronicles", "ezra": "ezra", "nehemiah": "nehemiah",
    "esther": "esther", "job": "job", "psalm": "psalms", "psalms": "psalms", "proverbs": "proverbs",
    "ecclesiastes": "ecclesiastes", "song of solomon": "songofsolomon", "isaiah": "isaiah",
    "jeremiah": "jeremiah", "lamentations": "lamentations", "ezekiel": "ezekiel", "daniel": "daniel",
    "hosea": "hosea", "joel": "joel", "amos": "amos", "obadiah": "obadiah", "jonah": "jonah",
    "micah": "micah", "nahum": "nahum", "habakkuk": "habakkuk", "zephaniah": "zephaniah",
    "haggai": "haggai", "zechariah": "zechariah", "malachi": "malachi",
    "matthew": "matthew", "mark": "mark", "luke": "luke", "john": "john", "acts": "acts",
    "romans": "romans", "1 corinthians": "1corinthians", "2 corinthians": "2corinthians",
    "galatians": "galatians", "ephesians": "ephesians", "eph": "ephesians", "eph.": "ephesians",
    "philippians": "philippians", "colossians": "colossians",
    "1 thessalonians": "1thessalonians", "2 thessalonians": "2thessalonians",
    "1 timothy": "1timothy", "2 timothy": "2timothy", "titus": "titus", "philemon": "philemon",
    "hebrews": "hebrews", "heb": "hebrews", "heb.": "hebrews",
    "james": "james", "1 peter": "1peter", "2 peter": "2peter",
    "1 john": "1john", "2 john": "2john", "3 john": "3john", "jude": "jude", "revelation": "revelation"
  },
  ru: {
    "бытие": "genesis", "бытия": "genesis", "исход": "exodus", "исхода": "exodus",
    "левит": "leviticus", "левита": "leviticus", "числа": "numbers", "чисел": "numbers",
    "второзаконие": "deuteronomy", "второзакония": "deuteronomy",
    "иисус навин": "joshua", "навин": "joshua", "навина": "joshua",
    "судьи": "judges", "судей": "judges", "руфь": "ruth", "руфи": "ruth",
    "1 царств": "1samuel", "2 царств": "2samuel", "3 царств": "1kings", "4 царств": "2kings",
    "1 паралипоменон": "1chronicles", "2 паралипоменон": "2chronicles",
    "ездра": "ezra", "ездры": "ezra", "неемия": "nehemiah", "неемии": "nehemiah",
    "есфирь": "esther", "есфири": "esther", "иов": "job", "иова": "job",
    "псалтирь": "psalms", "псалом": "psalms", "притчи": "proverbs", "притч": "proverbs",
    "екклесиаст": "ecclesiastes", "екклесиаста": "ecclesiastes",
    "песнь песней": "songofsolomon", "исаия": "isaiah", "исаии": "isaiah",
    "иеремия": "jeremiah", "иеремии": "jeremiah", "плач": "lamentations", "плач иеремии": "lamentations",
    "иезекииль": "ezekiel", "иезекииля": "ezekiel", "книга пророка иезекииля": "ezekiel",
    "послание петра": "1peter", "1 послание петра": "1peter", "2 послание петра": "2peter",
    "послание иоанна": "1john", "1 послание иоанна": "1john", "2 послание иоанна": "2john", "3 послание иоанна": "3john",
    "даниил": "daniel", "даниила": "daniel",
    "осия": "hosea", "осии": "hosea", "иоиль": "joel", "иоиля": "joel",
    "амос": "amos", "амоса": "amos", "авдий": "obadiah", "авдия": "obadiah",
    "иона": "jonah", "ионы": "jonah", "михей": "micah", "михея": "micah",
    "наум": "nahum", "наума": "nahum", "аввакум": "habakkuk", "аввакума": "habakkuk",
    "софония": "zephaniah", "софонии": "zephaniah", "аггей": "haggai", "аггея": "haggai",
    "захария": "zechariah", "захарии": "zechariah", "малахия": "malachi", "малахии": "malachi",
    "матфей": "matthew", "матфея": "matthew", "марк": "mark", "марка": "mark",
    "лука": "luke", "луки": "luke", "иоанн": "john", "иоанна": "john",
    "деяния": "acts", "деяний": "acts", "римлянам": "romans",
    "1 коринфянам": "1corinthians", "2 коринфянам": "2corinthians",
    "галатам": "galatians", "ефесянам": "ephesians", "еф": "ephesians", "еф.": "ephesians",
    "филиппийцам": "philippians", "колоссянам": "colossians",
    "1 фессалоникийцам": "1thessalonians", "2 фессалоникийцам": "2thessalonians",
    "1 тимофею": "1timothy", "2 тимофею": "2timothy", "титу": "titus", "филимону": "philemon",
    "евреям": "hebrews", "евр": "hebrews", "евр.": "hebrews",
    "иакова": "james", "иакову": "james", "1 петра": "1peter", "2 петра": "2peter",
    "1 иоанна": "1john", "2 иоанна": "2john", "3 иоанна": "3john",
    "иуды": "jude", "откровение": "revelation", "откровения": "revelation"
  },
  es: {
    "génesis": "genesis", "genesis": "genesis", "éxodo": "exodus", "exodo": "exodus",
    "levítico": "leviticus", "levitico": "leviticus", "números": "numbers", "numeros": "numbers",
    "deuteronomio": "deuteronomy", "josué": "joshua", "josue": "joshua",
    "jueces": "judges", "rut": "ruth",
    "1 samuel": "1samuel", "2 samuel": "2samuel", "1 reyes": "1kings", "2 reyes": "2kings",
    "1 crónicas": "1chronicles", "1 cronicas": "1chronicles",
    "2 crónicas": "2chronicles", "2 cronicas": "2chronicles",
    "esdras": "ezra", "nehemías": "nehemiah", "nehemias": "nehemiah",
    "ester": "esther", "job": "job", "salmos": "psalms", "salmo": "psalms",
    "proverbios": "proverbs", "eclesiastés": "ecclesiastes", "ecclesiastes": "ecclesiastes",
    "cantar de los cantares": "songofsolomon", "isaías": "isaiah", "isaias": "isaiah",
    "jeremías": "jeremiah", "jeremias": "jeremiah", "lamentaciones": "lamentations",
    "ezequiel": "ezekiel", "daniel": "daniel",
    "oseas": "hosea", "joel": "joel", "amós": "amos", "amos": "amos",
    "abdías": "obadiah", "abdias": "obadiah", "jonás": "jonah", "jonas": "jonah",
    "miqueas": "micah", "nahúm": "nahum", "nahum": "nahum",
    "habacuc": "habakkuk", "sofonías": "zephaniah", "sofonias": "zephaniah",
    "hageo": "haggai", "zacarías": "zechariah", "zacarias": "zechariah",
    "malaquías": "malachi", "malaquias": "malachi",
    "mateo": "matthew", "marcos": "mark", "lucas": "luke", "juan": "john",
    "hechos": "acts", "romanos": "romans",
    "1 corintios": "1corinthians", "2 corintios": "2corinthians",
    "gálatas": "galatians", "galatas": "galatians",
    "efesios": "ephesians", "filipenses": "philippians",
    "colosenses": "colossians",
    "1 tesalonicenses": "1thessalonians", "2 tesalonicenses": "2thessalonians",
    "1 timoteo": "1timothy", "2 timoteo": "2timothy", "tito": "titus", "filemón": "philemon", "filemon": "philemon",
    "hebreos": "hebrews", "santiago": "james",
    "1 pedro": "1peter", "2 pedro": "2peter",
    "1 juan": "1john", "2 juan": "2john", "3 juan": "3john",
    "judas": "jude", "apocalipsis": "revelation"
  }
};

// Map English book names to keys (backwards compatibility)
const ENGLISH_TO_KEY: Record<string, string> = INPUT_TO_KEY.en;

/**
 * Adjusts Psalm numbers when translating between different Bible traditions
 * Russian Synodal uses Septuagint numbering, KJV uses Hebrew numbering
 */
function adjustPsalmNumber(psalmNum: number, fromLang: string, toLang: string): number {
  // No adjustment needed if not involving Psalms or same numbering system
  if ((fromLang === 'en' && toLang === 'en') || (fromLang === 'ru' && toLang === 'ru')) {
    return psalmNum;
  }
  
  // Russian (Septuagint) to English (Hebrew) - common differences:
  // Russian Psalms 10-112 → add 1 (Russian 10 = English 11)
  // Russian Psalm 113 → split into English 114-115
  // Russian Psalms 114-115 → English 116
  // Russian Psalms 116-145 → add 1 (Russian 116 = English 117)
  // Russian Psalm 146-147 → English 147
  // Russian Psalm 148+ → same
  if (fromLang === 'ru' && toLang === 'en') {
    if (psalmNum >= 10 && psalmNum <= 112) return psalmNum + 1;
    if (psalmNum === 113) return 114; // First part
    if (psalmNum === 114) return 116; // Combined
    if (psalmNum === 115) return 116; // Combined
    if (psalmNum >= 116 && psalmNum <= 145) return psalmNum + 1;
    if (psalmNum === 146) return 147; // Combined
    if (psalmNum === 147) return 147; // Combined
  }
  
  // English (Hebrew) to Russian (Septuagint)
  if (fromLang === 'en' && toLang === 'ru') {
    if (psalmNum >= 11 && psalmNum <= 113) return psalmNum - 1;
    if (psalmNum === 114) return 113; // Split
    if (psalmNum === 115) return 113; // Split  
    if (psalmNum === 116) return 114; // Will be split
    if (psalmNum >= 117 && psalmNum <= 146) return psalmNum - 1;
    if (psalmNum === 147) return 146; // Will be split
  }
  
  // Spanish (typically follows Hebrew numbering like English)
  if (fromLang === 'ru' && toLang === 'es') {
    return adjustPsalmNumber(psalmNum, 'ru', 'en'); // Same adjustment as ru→en
  }
  if (fromLang === 'es' && toLang === 'ru') {
    return adjustPsalmNumber(psalmNum, 'en', 'ru'); // Same adjustment as en→ru
  }
  
  return psalmNum;
}

export function translateScriptureReference(reference: string, targetLanguage: string): string {
  if (!reference) return reference;
  
  // Extract book name and rest of reference
  const refLower = reference.toLowerCase().trim();
  
  // Try to find which language and book this is
  let sourceLanguage: string | null = null;
  let bookKey: string | null = null;
  let bookNameLength = 0;
  
  // Check each language's input mappings
  for (const [lang, bookMap] of Object.entries(INPUT_TO_KEY)) {
    // Sort book names by length (longest first) to match multi-word names first
    const sortedBooks = Object.keys(bookMap).sort((a, b) => b.length - a.length);
    
    for (const bookName of sortedBooks) {
      if (refLower.startsWith(bookName + ' ') || refLower === bookName) {
        sourceLanguage = lang;
        bookKey = bookMap[bookName];
        bookNameLength = bookName.length;
        break;
      }
    }
    if (bookKey) break;
  }
  
  // If can't identify or already in target language, return as-is
  if (!bookKey || !sourceLanguage || sourceLanguage === targetLanguage) {
    return reference;
  }
  
  // Get the rest of the reference (after the book name)
  const restOfRef = reference.substring(bookNameLength).trim();
  
  // Get translated book name
  const translatedBook = BOOK_TRANSLATIONS[targetLanguage]?.[bookKey];
  if (!translatedBook) return reference;
  
  // Extract chapter and verse numbers for Psalm number adjustment
  const numMatch = restOfRef.match(/^(\d+)(.*)$/);
  
  if (numMatch && bookKey === 'psalms') {
    // Adjust Psalm number if needed
    const originalChapter = parseInt(numMatch[1]);
    const adjustedChapter = adjustPsalmNumber(originalChapter, sourceLanguage, targetLanguage);
    const remainder = numMatch[2]; // Contains :verses or other suffix
    
    return `${translatedBook} ${adjustedChapter}${remainder}`;
  }
  
  // Reconstruct with translated book name (no adjustment needed)
  return `${translatedBook} ${restOfRef}`;
}
